import imageCompression from "browser-image-compression";

export type CompressOptions = {
  maxWidthOrHeight?: number;
  initialQuality?: number;
};

export async function compressImage(
  file: File,
  options: CompressOptions = {},
): Promise<File> {
  const { maxWidthOrHeight = 800, initialQuality = 0.5 } = options;

  // Note: omitting maxSizeMB — the package iterates encode/measure/re-encode
  // when it's set, which 10× the compression time without changing the output
  // for already-small targets like ours. One pass at the chosen quality is
  // enough.
  const compressed = await imageCompression(file, {
    maxWidthOrHeight,
    initialQuality,
    useWebWorker: true,
    fileType: "image/jpeg",
  });

  const newName = file.name.replace(
    /\.(png|heic|heif|webp|gif|tiff?|bmp)$/i,
    ".jpg",
  );

  return new File([compressed], newName, { type: "image/jpeg" });
}
